export const SET_RESIDENTIAL_PLAN_TERM =
  "residentialPlanConfig/SET_RESIDENTIAL_PLAN_TERM";
